import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Announcement extends Component {
  render() {
    const { duyurular } = this.props;

    if (!duyurular?.length) return null;

    return (
      <section className="t-dashboardBlock t-dashboardBlock--announcements" aria-label="Duyurular">
        <header className="t-dashboardBlockHead">
          <h2>Duyurular</h2>
          <p>Güncel haberler ve önemli bilgilendirmeler</p>
        </header>

        <div className="t-dashboardAnnouncePanel t-dashboardGlass">
          {duyurular.map((duyuru) => (
            <Link
              key={duyuru.id}
              to={`/Home/AnnouncementDetail/${duyuru.id}`}
              className="t-dashboardAnnounceRow"
            >
              <div className="t-dashboardAnnounceRowIcon" aria-hidden="true">
                <i className="t-icon-bell" />
              </div>
              <div className="t-dashboardAnnounceRowBody">
                <span className="t-dashboardAnnounceRowDate">{duyuru.tarih}</span>
                <strong className="t-dashboardAnnounceRowTitle">{duyuru.konu}</strong>
              </div>
              <i className="t-icon-arrow-right1 t-dashboardAnnounceRowArrow" aria-hidden="true" />
            </Link>
          ))}
        </div>
      </section>
    );
  }
}
